import { Controller } from "@hotwired/stimulus"

// Formats: "time" (default) → "3:04 PM", "short" → "Apr 9 3:04pm"
export default class extends Controller {
  static values = { format: { type: String, default: "time" } }

  connect() {
    const dt = new Date(this.element.getAttribute("datetime"))
    if (isNaN(dt)) return

    if (this.formatValue === "short") {
      const month = dt.toLocaleString(undefined, { month: "short" })
      const day = dt.getDate()
      const time = dt.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }).toLowerCase()
      this.element.textContent = `${month} ${day} ${time}`
    } else {
      this.element.textContent = dt.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    }

    this.element.title = dt.toLocaleString(undefined, {
      year: "numeric", month: "long", day: "numeric",
      hour: "numeric", minute: "2-digit"
    })
  }
}
